// extracted by mini-css-extract-plugin
module.exports = {"content":"BlogRelatedArticles_content__O0g4T"};